/**
 * Shared TypeScript types for expert-review (common.types.ts).
 *
 * Belongs here: domain types.
 * Does not belong here: React components.
 */
export enum ImageAvailability {
  UNKNOWN = 'UNKNOWN',
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

